module.exports = __webpack_public_path__ + "static/ReferAFriend-c8f2872fb26ad2a5776025301be1147d.png";